import { Component, Input } from '@angular/core';

@Component({
  selector: 'mfp-add-button',
  templateUrl: './add-button.component.html',
  styleUrls: ['./add-button.component.scss']
})
export class AddButtonComponent {
  @Input() icon = 'assets/icons/add.svg';
  @Input() iconPosition: 'left' | 'right' = 'left';
  @Input() iconSize: 'small' | 'medium' | 'large' = 'medium';
  @Input() label = '';
  @Input() labelSize: 'small' | 'medium' = 'medium';
  @Input() color: 'primary' | 'dark' = 'primary';

  constructor() {}
}
